/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  DeleteApiProjectprioritiesIdMutationResponse,
  DeleteApiProjectprioritiesIdPathParams,
} from '../models/DeleteApiProjectprioritiesId.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { deleteApiProjectprioritiesIdMutationResponseSchema } from '../zod/deleteApiProjectprioritiesIdSchema.ts';
import { useMutation } from '@tanstack/react-query';

export const deleteApiProjectprioritiesIdMutationKey = () =>
  [{ url: '/api/projectpriorities/:id' }] as const;

export type DeleteApiProjectprioritiesIdMutationKey = ReturnType<
  typeof deleteApiProjectprioritiesIdMutationKey
>;

/**
 * {@link /api/projectpriorities/:id}
 */
export async function deleteApiProjectprioritiesId(
  id: DeleteApiProjectprioritiesIdPathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiProjectprioritiesIdMutationResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'DELETE',
    url: `/api/projectpriorities/${id}`,
    ...requestConfig,
  });
  return deleteApiProjectprioritiesIdMutationResponseSchema.parse(res.data);
}

/**
 * {@link /api/projectpriorities/:id}
 */
export function useDeleteApiProjectprioritiesId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiProjectprioritiesIdMutationResponse,
      ResponseErrorConfig<Error>,
      { id: DeleteApiProjectprioritiesIdPathParams['id'] },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? deleteApiProjectprioritiesIdMutationKey();

  return useMutation<
    DeleteApiProjectprioritiesIdMutationResponse,
    ResponseErrorConfig<Error>,
    { id: DeleteApiProjectprioritiesIdPathParams['id'] },
    TContext
  >(
    {
      mutationFn: async ({ id }) => {
        return deleteApiProjectprioritiesId(id, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
